/** Created by azhou on 2019/3/6.*/
<template>
  <div class="pr-5">
    <div class="Adims pt-2flex-wrap">
      <div class="mr-4 pl-5">
        <h2 class="font-weight-bold">{{userLoginMessage.truename}}</h2>
      </div>
      <span class="mr-5  text-muted">工号: <span class="text-blue">{{userLoginMessage.username}}</span></span>
      <span class="mr-5  text-muted">手机号: <span class="text-blue">{{userLoginMessage.mobile}}</span></span>
      <span class="mr-5  text-muted">登录次数: <span class="text-blue">{{userLoginMessage.login_num}}</span></span>
      <span class="text-muted mr-5 ">上次登陆时间: <span class="text-blue">{{userLoginMessage.login_time | formatTimestamp(1)}}</span></span>
      <span class="text-muted mr-5 ">上次登陆IP: <span class="text-blue">{{userLoginMessage.ip}}</span></span>
      <el-button class="bg-login text-white lis" @click="$router.push('/')">去首页</el-button>
    </div>
    <div class="automatic pl-5" v-if="isAdmin">
      <div  class="text-link mr-5" @click="changeAdminPhone">修改密码</div>
      <div class="automatic-nane mr-5" @click="automaticSwitch">
        <div class="bottom" :class="switchs?'':'div'">自动审核订单</div>
        <span class="mr-2 " :class="switchs?'':'span'">{{switchs?'已开启':'已关闭'}}</span>
      </div>
    </div>
    <el-dialog
      title="设置管理员账号"
      :visible.sync="centerDialogVisible"
      width="30%"
      top="20vh"
      center>
      <el-tabs v-model="activeName">
        <!-- <el-tab-pane label="修改手机号" name="first">
          <el-button class="text-link mt-4" @click="changeAdminPhone">去修改手机号</el-button>
        </el-tab-pane> -->
        <el-tab-pane label="修改密码" name="second">
          <el-input class="mt-4 mb-3" v-model="pwd" placeholder="请输入修改密码" show-password />
          <el-input v-model="newpwd" placeholder="请再次输入" show-password />
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" v-show="activeName='second'" @click="cAdminPass">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'AdminHeader',
    computed: {
      ...mapState(['userLoginMessage','IndexData']),
      ...mapGetters(['storeInfo','isAdmin'])
    },
    data () {
      return {
        centerDialogVisible: false,
        pwd: '',
        newpwd: '',
        switchs:false,
        activeName: 'first'
      }
    }, 
    mounted() {
      // if(this.isAdmin==true) this.automaticSwitch()
      console.log(this.IndexData);
    },
    watch:{
      IndexData(){
        if(this.IndexData.autoOrder){
            this.switchs=this.IndexData.autoOrder==1?true:false
        }
      },
    },
    methods: {
      async automaticSwitch(){
        let resData = await this.$axios.post('pc/Admin/AutoVerifyOrderSwitch',{})
        if (resData.code === '00000') {
          this.$message.success(resData.info.autoOrder==1?'自动核审已开启':'自动核审已关闭')
          this.switchs=resData.info.autoOrder==1?true:false
        }
      },
      async cAdminPass () {
        if (!this.pwd || !this.newpwd) { this.$message.warning('请输入密码！'); return }
        if (this.pwd != this.newpwd) { this.$message.warning('两次输入密码不一致！'); return }
        let resData = await this.$axios.post('/pc/Admin/SavePwd', {
          pwd: this.pwd,
          pwd2: this.newpwd
        })
        if (resData.code === '00000') {
          this.centerDialogVisible = false
          this.$message.success('修改成功！')
        }
      },
      changeAdminPhone () {
        this.centerDialogVisible=true
        // this.$router.push({name:'addEditAdmin',query:{
        //   account:'account',
        //   username:this.userLoginMessage.username,
        //   truename:this.userLoginMessage.truename,
        //   mobile:this.userLoginMessage.mobile,
        //   status:this.userLoginMessage.status,
        //   position_id:this.userLoginMessage.position_id
        // }})
      }
    }
  }
</script>
<style scoped>
  .pr-5{
    min-width: 1400px;
  }
  .Adims{
    margin-top: 20px;
    width: 100%;
    display: flex;
  }
  .Adims>div,.Adims>span{
    float: left;
  }
  .Adims .el-button{
    margin-left: auto;
  }
  .lis{
    flex: right !important;
  }
  .automatic{
    width: 100%;
    cursor: pointer;
  }
  .automatic div{
    float: left;
  }
  .automatic-nane{
    margin-top: -10px;
    overflow: hidden;
  }
  .automatic-nane span{
    display: block;
    float: left;
    padding:6px 15px;
    background-color: #fff;
    border-radius: 0px 4px 4px 0px;
    color: #09af09;
    border: 1px solid #E4E7ED;

  }
  .automatic-nane .span{
    color: #ff0000;
  }
  .automatic-nane .bottom{
    background-color: var(--smtc-color-primary);
    border: 1px solid var(--smtc-color-primary);
    color: #Fff;
    padding: 6px 20px;
    font-size: 14px;
    border-radius: 4px 0 0 4px;
    float: left;
  }
  .automatic-nane .div{
    background-color: #999;
    border: 1px solid #999;
  }
</style>
